/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


require('./bootstrap');
require('./datatables');

// imported js
window.io = require('socket.io-client');
require('jquery-mask-plugin');

// populate.js
window.populate = require('populate.js');

// moment js
window.moment = require('moment');
window.moment.locale('pt-br');

import 'jquery-ui/ui/widgets/tabs';
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/droppable';
import 'jquery-ui/ui/widgets/resizable';
import 'jquery-ui/ui/widgets/button';
import 'jquery-ui/ui/widgets/autocomplete';


window.Vue = require('vue');
window.Vuex = require('vuex');
Vue.use(Vuex);

import ViaCep from 'vue-viacep';
Vue.use(ViaCep);

// vue-wysiwyg
import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, {
    hideModules: { image: true, code: true, table: true, separator: true },
    image: {},
    maxHeight: "500px",
});

// apex charts
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

// CommonJS
window.Swal = require('sweetalert2')


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('loading-indicator-component', require('./components/LoadingIndicatorComponent.vue').default);
Vue.component('home-component', require('./components/HomeComponent.vue').default);

// alerts
Vue.component('inline-alert-component', require('./components/alerts/InLine.vue').default);

// users box
Vue.component('default-user-box-component', require('./components/boxes/DefaultUserBox.vue').default);
Vue.component('user-realtime-box-component', require('./components/boxes/UserRealtimeBox.vue').default);
Vue.component('users-box-component', require('./components/boxes/Users.vue').default);
Vue.component('users2-box-component', require('./components/boxes/Users2.vue').default);
Vue.component('count-users-box-component', require('./components/boxes/CountUsersBox.vue').default);

// inputs
Vue.component('start-end-date-component', require('./components/filters/StartEndDate.vue').default);
Vue.component('input-component', require('./components/filters/DefaultInput.vue').default);
Vue.component('multiselect-component', require('./components/filters/MultiSelect.vue').default);
Vue.component('group-extension-component', require('./components/filters/GroupExtension.vue').default);
Vue.component('select-component', require('./components/filters/DefaultSelect.vue').default);
Vue.component('texteditor-component', require('./components/Wysiwyg.vue').default);
Vue.component('textarea-component', require('./components/filters/Textarea.vue').default);
Vue.component('costumers-select-component', require('./components/filters/CostumerSelect.vue').default);
Vue.component('users-component', require('./components/users/UsersComponent').default);
Vue.component('queues-and-extensions-component', require('./components/filters/GroupsAndExtensions.vue').default);
Vue.component('queues-filter-component', require('./components/filters/GroupsFilter.vue').default);

// charts
Vue.component('chart-bar-component', require('./components/charts/BarComponent.vue').default);
Vue.component('chart-line-component', require('./components/charts/LineComponent.vue').default);
Vue.component('chart-donut-component', require('./components/charts/DonutComponent.vue').default);

// modals
Vue.component('modal-component', require('./components/modals/ModalComponent.vue').default);
Vue.component('releases-modal-component', require('./components/modals/ReleasesModalComponent.vue').default);
Vue.component('costumer-data-component', require('./components/modals/CostumerDataComponent.vue').default);

Vue.component('dashboard-app', require('./components/dashboard/DashboardApp.vue').default);
Vue.component('call-control-app', require('./components/call_control/CallControlApp.vue').default);

Vue.component('home-realtime', require('./components/realtime/HomeRealtime.vue').default)
Vue.component('profile-modal', require('./components/users/UserProfileModal.vue').default);

window.app = new Vue({
    el: '#app',
    mounted() {
        // Expor função global para abrir modal
        window.openProfileModal = () => {
            this.$refs.profileModal.open();
        };
    }
});
